import React from 'react';
import { Redirect } from 'react-router-dom';
import { buildUrl } from 'modules/utils/url';
import { SearchResults as SearchResultsProps } from './components/Results';
import { Results, SearchResultsZeroState } from './components';

function SearchResults({ answers, searchString }: SearchResultsProps) {
  let searchResults = answers;
  if (answers.length === 0) {
    return <SearchResultsZeroState />;
  }
  if (answers.length === 1) {
    const answer = searchResults[0];
    return <Redirect to={buildUrl(String(answer.categoryId), String(answer.id))} />;
  }
  if (answers.length >= 10) {
    searchResults = answers.slice(0, 10);
  }
  return <Results answers={searchResults} searchString={searchString} />;
}

export default SearchResults;
